$(document).ready(function () {
  console.log('Loaded homepage script');

  setTimeout(function () {
    var windowLocation = String(window.location.href);
    if (windowLocation.indexOf('?vip') != -1) {
      $('.ea_outer').css('display', 'flex');
    }
  }, 500);

  $('.ea_outer').click(function () {
    $('.ea_outer').hide();
  });

  $('.bdp_gallery_btn a').click(function (evt) {
    evt.preventDefault();
    $('.pp_popup').css('display', 'flex');
  });

  $('.pp_popup').click(function () {
    $('.pp_popup').hide();
  });

  // ---- SAFE SLICK INIT WRAPPER ----
  if (typeof $.fn.slick === 'function') {
    console.log('Slick found, initializing testimonial sliders');

    $('.hm_testimonials_carousel:not(.hm_testimonials_carousel_bigger)').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '80px',
      arrows: true,
      dots: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
      responsive: [
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1,
            centerPadding: '30px'
          }
        }
      ]
    });

    $('.hm_testimonials_carousel.hm_testimonials_carousel_bigger').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '80px',
      arrows: true,
      dots: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            centerPadding: '64px'
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerPadding: '48px'
          }
        },
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1,
            centerPadding: '30px'
          }
        }
      ]
    });
  } else {
    console.warn('Slick not found – .hm_testimonials_carousel will appear stacked (no slider).');
  }
  // ---- END SAFE SLICK INIT WRAPPER ----

  $('.hm_primary_btn').click(function (evt) {
    if (String(window.location.href).indexOf('adv') != -1) {
      // Do nothing, use default behavior on adv pages
    } else {
      evt.preventDefault();
      $('html, body').animate({
        scrollTop: $(".bdp_container").offset().top - 100
      }, 500);
    }
  });

  $('.hmf_block').click(function () {
    $(this).toggleClass('active');
    $(this).find('.hmf_cont_block').slideToggle();
  });
});
